import { useEffect } from 'react';
import ReactGA from 'react-ga4'; // or 'react-ga' for UA tracking
import { useLocation } from 'react-router-dom';

/**
 * 커스텀 훅: GA 초기화 및 페이지뷰 추적
 * @param {string} trackingId - UA- 또는 G- 로 시작하는 트래킹 ID
 * @param {boolean} debug - 디버그 모드 여부 (옵션)
 */
export function useAnalytics(trackingId, debug = false) {
  const location = useLocation();

  // 초기화
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize(trackingId, { debug });
    } else if (debug) {
      ReactGA.initialize(trackingId, { debug });
    }
  }, [trackingId, debug]);

  // 페이지뷰 전송
  useEffect(() => {
    // location.pathname + location.search
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);
}
